import { Component, OnDestroy, OnInit, ViewChild, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { GetCustomerStat, StatsClient } from 'src/app/generated-client/generated-client';

import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Moment } from 'moment';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'da-customer-stats',
    templateUrl: './customer-stats.component.html',
    styleUrl: './customer-stats.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatInput, MatDatepickerInput, FormsModule, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DecimalPipe]
})
export class CustomerStatsComponent implements OnInit, OnDestroy {
  private statsClient = inject(StatsClient);


  dataSource = new MatTableDataSource<GetCustomerStat & { percentage: number }>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private _fromDate = signal<Moment>(null);
  set fromDate(value: Moment) {
    this._fromDate.set(value);
    this.queryData();
  }
  get fromDate() {
    return this._fromDate();
  }

  private _endDate = signal<Moment>(null);
  set endDate(value: Moment) {
    this._endDate.set(value);
    this.queryData();
  }
  get endDate() {
    return this._endDate();
  }
  totalConversions = signal(0);
  private lastQuerySubscription: Subscription;

  ngOnDestroy() {
    this.lastQuerySubscription?.unsubscribe();
  }

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.queryData();
  }

  clearDates() {
    this._fromDate.set(null);
    this._endDate.set(null);
    this.queryData();
  }

  currentMonth() {
    this._fromDate.set(moment().utc().startOf('month'));
    this._endDate.set(moment().utc().endOf('month'));
    this.queryData();
  }

  lastMonth() {
    this._fromDate.set(moment().utc().add(-1, 'M').startOf('month'));
    this._endDate.set(moment().utc().add(-1, 'M').endOf('month'));
    this.queryData();
  }

  private queryData() {
    if (this.lastQuerySubscription) {
      this.lastQuerySubscription.unsubscribe();
    }

    const fromDate = this._fromDate() ? this._fromDate().toDate() : undefined;
    const endDate = this._endDate() ? this._endDate().endOf('day').toDate() : undefined;
    this.lastQuerySubscription = this.statsClient
      .getStatsPerCustomer(fromDate, endDate)
      .subscribe((cs: GetCustomerStat[]) => this.setData(cs));
  }

  private setData(customerStats: GetCustomerStat[]) {
    const totalConversions = customerStats.reduce((sum, current) => sum + current.conversions, 0);
    this.totalConversions.set(totalConversions);
    // The percentage of conversions per customer is not calculated on the backend, so we're
    // doing that here for display purposes.
    this.dataSource.data = customerStats.map(
      (cs: GetCustomerStat) =>
        ({
          percentage: (100 * cs.conversions) / totalConversions,
          ...cs
        } as GetCustomerStat & { percentage: number })
    );
  }
}
